import { render, staticRenderFns } from "./app-tokens.vue?vue&type=template&id=5003256a"
import script from "./app-tokens.vue?vue&type=script&lang=js"
export * from "./app-tokens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports